module.exports = __webpack_public_path__ + "static/img/authDetail.9567d8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/software/wxMini/authDetail.jpg
// module id = KDMm
// module chunks = 0